const IconPrivacyChoices = (): JSX.Element => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.0479 0H6.95205C3.07877 0 0 3.1 0 7C0 10.9 3.07877 14 6.95205 14H22.0479C25.9212 14 29 10.9 29 7C29 3.1 25.8219 0 22.0479 0ZM1.16 6.99999C1.16 3.78159 3.65733 1.16665 6.73096 1.16665H16.24L13.2624 12.8333H6.73096C3.65733 12.8333 1.16 10.2184 1.16 6.99999Z"
        fill="#0066FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.21539 12.7666H14.2583L17.469 1.16663H7.21539C3.90111 1.16663 1.20825 3.76663 1.20825 6.96663C1.20825 10.1666 3.90111 12.7666 7.21539 12.7666Z"
        fill="white"
      />
      <path
        d="M12.5493 3.65C12.7565 3.85 12.86 4.25 12.6529 4.45L8.30289 9.35C8.19932 9.45 8.09575 9.55 7.99218 9.55C7.78504 9.65 7.47432 9.65 7.26718 9.45L4.98861 7.25C4.78147 7.05 4.78147 6.65 4.98861 6.45C5.19575 6.25 5.61004 6.25 5.81718 6.45L7.68147 8.15L11.6172 3.65C11.8243 3.45 12.2386 3.45 12.5493 3.65Z"
        fill="#0066FF"
      />
      <path
        d="M24.4946 3.65C24.7018 3.85 24.7018 4.25 24.4946 4.45L22.3196 6.65L24.5982 8.85C24.8054 9.05 24.8054 9.45 24.5982 9.65C24.3911 9.85 23.9768 9.85 23.7696 9.65L21.4911 7.45L19.2125 9.65C19.0054 9.85 18.5911 9.85 18.3839 9.65C18.1768 9.45 18.1768 9.05 18.3839 8.85L20.5589 6.65L18.2804 4.45C18.0732 4.25 18.0732 3.85 18.2804 3.65C18.4875 3.45 18.9018 3.45 19.1089 3.65L21.3875 5.85L23.6661 3.65C23.8732 3.45 24.2875 3.45 24.4946 3.65Z"
        fill="white"
      />
    </>
  );
};

export default IconPrivacyChoices;
